import { getNoaId } from "../../utils/session.utils";
import { dateFormats } from "../../helpers/convertDate";
import apiClient from "../../utils/api.client";
// Contants
const dates = dateFormats();

const getStock = async (page, pageSize, sort, filters) => {
  /* const {criteria, field} = sort;
  const {type, gameId, raffleNumber, dateFrom, dateTypeName} = filters;

  const url = `${getDeliveryServiceUrl()}/coupon/search?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'raffleId'}${organizationId ? `&organizationId=${organizationId}` : ''}`;
  let urlFilters = "";
  if (type != undefined) {
    urlFilters += `&gameType=${type || 1}`;
  }
  if (gameId != undefined) {
    urlFilters += `&gameId=${gameId}`;
  }
  if (raffleNumber != undefined) {
    urlFilters += `&raffleNumber=${raffleNumber}`;
  }
  if (dateFrom != undefined) {
    if (!isNaN(Date.parse(dateFrom))) {
      urlFilters += `&${dateTypeName}=${dates.formatDate(dateFrom)}`;
    }
  }
  const fetchUrl = url + urlFilters;

  return fetch(fetchUrl, {
    method: "GET",
    headers: {"Content-Type": "application/json", "accept": "application/json"},
  })
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */

  const noaId = getNoaId();

  const { criteria, field } = sort;

  const { type, gameId, raffleNumber, dateFrom, dateTypeName } = filters;

  const url = `/delivery-service/coupon/search?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "raffleId"}${noaId ? `&organizationId=${noaId}` : ""}`;

  let urlFilters = "";
  if (type != undefined) {
    urlFilters += `&gameType=${type || 1}`;
  }
  if (gameId != undefined) {
    urlFilters += `&gameId=${gameId}`;
  }
  if (raffleNumber != undefined) {
    urlFilters += `&raffleNumber=${raffleNumber}`;
  }
  if (dateFrom != undefined) {
    if (!isNaN(Date.parse(dateFrom))) {
      urlFilters += `&${dateTypeName}=${dates.formatDate(dateFrom)}`;
    }
  }

  const fetchUrl = url + urlFilters;

  try {
    const response = await apiClient.get(fetchUrl);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getStock EP: ", error);
    throw error;
  }
};

const getAllStock = async (sort, filters) => {
  /* const {criteria, field} = sort;
  const {type, gameId, raffleNumber, dateFrom, dateTypeName} = filters;

  const url = `${getDeliveryServiceUrl()}/coupon/search/unpaged?&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'raffleId'}${organizationId ? `&organizationId=${organizationId}` : ''}`;
  let urlFilters = "";
  if (type != undefined) {
    urlFilters += `&gameType=${type || 1}`;
  }
  if (gameId != undefined) {
    urlFilters += `&gameId=${gameId}`;
  }
  if (raffleNumber != undefined) {
    urlFilters += `&raffleNumber=${raffleNumber}`;
  }
  if (dateFrom != undefined) {
    if (!isNaN(Date.parse(dateFrom))) {
      urlFilters += `&${dateTypeName}=${dates.formatDate(dateFrom)}`;
    }
  }
  const fetchUrl = url + urlFilters;

  return fetch(fetchUrl, {
    method: "GET",
    headers: {"Content-Type": "application/json", "accept": "application/json"},
  })
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */
  const noaId = getNoaId();
  const { criteria, field } = sort;
  const { type, gameId, raffleNumber, dateFrom, dateTypeName } = filters;

  const url = `/delivery-service/coupon/search/unpaged?&orderCriteria=${criteria || "DESC"}&orderField=${field || "raffleId"}${noaId ? `&organizationId=${noaId}` : ""}`;
  let urlFilters = "";
  if (type != undefined) {
    urlFilters += `&gameType=${type || 1}`;
  }
  if (gameId != undefined) {
    urlFilters += `&gameId=${gameId}`;
  }
  if (raffleNumber != undefined) {
    urlFilters += `&raffleNumber=${raffleNumber}`;
  }
  if (dateFrom != undefined) {
    if (!isNaN(Date.parse(dateFrom))) {
      urlFilters += `&${dateTypeName}=${dates.formatDate(dateFrom)}`;
    }
  }
  const fetchUrl = url + urlFilters;

  try {
    const response = await apiClient.get(fetchUrl);
    const data = response.data;

    return data;
  } catch (error) {
    console.log("Error at getAllStock EP", error);
    throw error;
  }
};

const getReceipts = async (page, pageSize, sort, filters) => {
  /* const { criteria, field } = sort;
  const { gameType, gameId, agencyNumberFrom, agencyNumberTo, dateType, date } = filters;

  const url = `${getDeliveryServiceUrl()}/deliverynote/search-receipts?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${field || 'agencyNumber'}&orderCriteria=${criteria || 'DESC'}`;
  let urlFilters = ``;
	
  if(gameType){
    urlFilters += `&gameType=${gameType}`
  }
  if(gameId){
    urlFilters += `&gameId=${gameId}`
  }
  if(agencyNumberFrom){
    urlFilters += `&agencyNumberFrom=${agencyNumberFrom}`
  }
  if(agencyNumberTo){
    urlFilters += `&agencyNumberTo=${agencyNumberTo}`
  }
  if(dateType){
    if(date){
      if(dateType === 1){
        urlFilters += `&createDate=${dates.formatDate(date)}`
      }else if(dateType === 2){
        urlFilters += `&raffleDate=${dates.formatDate(date)}`
      }else{
        urlFilters += `&expirationDate=${dates.formatDate(date)}`
      }
    }
  }

  const fetchUrl = url + urlFilters;
  return fetch(fetchUrl, {
    method: "GET",
    headers: {"Content-Type": "application/json", "accept": "application/json"},
  })
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */

  const { criteria, field } = sort;
  const { gameType, gameId, agencyNumberFrom, agencyNumberTo, dateType, date } =
    filters;

  const url = `/delivery-service/deliverynote/search-receipts?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${field || "agencyNumber"}&orderCriteria=${criteria || "DESC"}`;
  let urlFilters = ``;

  if (gameType) {
    urlFilters += `&gameType=${gameType}`;
  }
  if (gameId) {
    urlFilters += `&gameId=${gameId}`;
  }
  if (agencyNumberFrom) {
    urlFilters += `&agencyNumberFrom=${agencyNumberFrom}`;
  }
  if (agencyNumberTo) {
    urlFilters += `&agencyNumberTo=${agencyNumberTo}`;
  }
  if (dateType) {
    if (date) {
      if (dateType === 1) {
        urlFilters += `&createDate=${dates.formatDate(date)}`;
      } else if (dateType === 2) {
        urlFilters += `&raffleDate=${dates.formatDate(date)}`;
      } else {
        urlFilters += `&expirationDate=${dates.formatDate(date)}`;
      }
    }
  }

  const fetchUrl = url + urlFilters;

  try {
    const response = await apiClient.get(fetchUrl);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getReceipts EP: ", error);
    throw error;
  }
};

const getAllReceipts = async (sort, filters) => {
  /* const { criteria, field } = sort;
  const { gameType, gameId, agencyNumberFrom, agencyNumberTo, dateType, date } = filters;

  const url = `${getDeliveryServiceUrl()}/deliverynote/search-receipts/unpaged?&orderField=${field || 'agencyNumber'}&orderCriteria=${criteria || 'DESC'}`;
  let urlFilters = ``;
	
  if(gameType){
    urlFilters += `&gameType=${gameType}`
  }
  if(gameId){
    urlFilters += `&gameId=${gameId}`
  }
  if(agencyNumberFrom){
    urlFilters += `&agencyNumberFrom=${agencyNumberFrom}`
  }
  if(agencyNumberTo){
    urlFilters += `&agencyNumberTo=${agencyNumberTo}`
  }
  if(dateType){
    if(date){
      if(dateType === 1){
        urlFilters += `&createDate=${dates.formatDate(date)}`
      }else if(dateType === 2){
        urlFilters += `&raffleDate=${dates.formatDate(date)}`
      }else{
        urlFilters += `&expirationDate=${dates.formatDate(date)}`
      }
    }
  }

  const fetchUrl = url + urlFilters;
  return fetch(fetchUrl, {
    method: "GET",
    headers: {"Content-Type": "application/json", "accept": "application/json"},
  })
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */
  const { criteria, field } = sort;
  const { gameType, gameId, agencyNumberFrom, agencyNumberTo, dateType, date } =
    filters;

  const url = `/delivery-service/deliverynote/search-receipts/unpaged?&orderField=${field || "agencyNumber"}&orderCriteria=${criteria || "DESC"}`;
  let urlFilters = ``;

  if (gameType) {
    urlFilters += `&gameType=${gameType}`;
  }
  if (gameId) {
    urlFilters += `&gameId=${gameId}`;
  }
  if (agencyNumberFrom) {
    urlFilters += `&agencyNumberFrom=${agencyNumberFrom}`;
  }
  if (agencyNumberTo) {
    urlFilters += `&agencyNumberTo=${agencyNumberTo}`;
  }
  if (dateType) {
    if (date) {
      if (dateType === 1) {
        urlFilters += `&createDate=${dates.formatDate(date)}`;
      } else if (dateType === 2) {
        urlFilters += `&raffleDate=${dates.formatDate(date)}`;
      } else {
        urlFilters += `&expirationDate=${dates.formatDate(date)}`;
      }
    }
  }

  const fetchUrl = url + urlFilters;

  try {
    const response = await apiClient.get(fetchUrl);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllReceipts EP: ", error);
    throw error;
  }
};

// WARNING: Currently this ep returns a status 500, consult with backend
const getPaymentsPrizes = async (page, pageSize, sort, filters) => {
  /* const {criteria, field} = sort;
  const {typeAgency, agencyFrom, agencyTo, dateType, dateFrom, dateTo, type, gameId} = filters;

  const dateFromFormat = dateFrom?.toISOString()?.split('T')[0]?.split('-')?.reverse()?.join('-');
  const dateToFormat = dateTo?.toISOString()?.split('T')[0]?.split('-')?.reverse()?.join('-');

  const url = `${getDeliveryServiceUrl()}/prizes/payments/search-paid-prizes?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'paymentDate'}`;

  const urlfilters = `${type ? `&gameType=${type}` : ''}${gameId ? `&gameId=${gameId}` : ''}${typeAgency ? `&agencyType=${typeAgency}` : ''}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ''}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ''}${dateType ? `&searchDateType=${dateType}` : ''}${dateFrom ? `&searchDateFrom=${dateFromFormat}` : ''}${dateTo ? `&searchDateTo=${dateToFormat}` : ''}`

  const fetchUrl = url + urlfilters;

  return fetch(fetchUrl, {
    method: "GET",
    headers: {"Content-Type": "application/json", "accept": "application/json"},
  })
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */
  const { criteria, field } = sort;
  const {
    typeAgency,
    agencyFrom,
    agencyTo,
    dateType,
    dateFrom,
    dateTo,
    type,
    gameId,
  } = filters;

  const dateFromFormat = dateFrom
    ?.toISOString()
    ?.split("T")[0]
    ?.split("-")
    ?.reverse()
    ?.join("-");
  const dateToFormat = dateTo
    ?.toISOString()
    ?.split("T")[0]
    ?.split("-")
    ?.reverse()
    ?.join("-");
  
  const noaId = getNoaId()

  const url = `/delivery-service/prizes/payments/search-paid-prizes?organizationId=${noaId}&pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderCriteria=${criteria || "DESC"}&orderField=${field || "paymentDate"}`;

  const urlfilters = `${type ? `&gameType=${type}` : ""}${gameId ? `&gameId=${gameId}` : ""}${typeAgency ? `&agencyType=${typeAgency}` : ""}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ""}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ""}${dateType ? `&searchDateType=${dateType}` : ""}${dateFrom ? `&searchDateFrom=${dateFromFormat}` : ""}${dateTo ? `&searchDateTo=${dateToFormat}` : ""}`;

  const fetchUrl = url + urlfilters;

  try {
    const response = await apiClient.get(fetchUrl);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getPaymentsPrizes EP: ", error);
    throw error;
  }
};

// WARNING: Currently this ep returns a status 500, consult with backend
const getAllPaymentsPrizes = async (sort, filters) => {
  /* const {criteria, field} = sort;
  const {typeAgency, agencyFrom, agencyTo, dateType, dateFrom, dateTo, type, gameId} = filters;

  const dateFromFormat = dateFrom?.toISOString()?.split('T')[0]?.split('-')?.reverse()?.join('-');
  const dateToFormat = dateTo?.toISOString()?.split('T')[0]?.split('-')?.reverse()?.join('-');

  const url = `${getDeliveryServiceUrl()}/prizes/payments/search-paid-prizes/unpaged?&orderCriteria=${criteria || 'DESC'}&orderField=${field || 'paymentDate'}`;

  const urlfilters = `${type ? `&gameType=${type}` : ''}${gameId ? `&gameId=${gameId}` : ''}${typeAgency ? `&agencyType=${typeAgency}` : ''}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ''}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ''}${dateType ? `&searchDateType=${dateType}` : ''}${dateFrom ? `&searchDateFrom=${dateFromFormat}` : ''}${dateTo ? `&searchDateTo=${dateToFormat}` : ''}`

  const fetchUrl = url + urlfilters;

  return fetch(fetchUrl, {
    method: "GET",
    headers: {"Content-Type": "application/json", "accept": "application/json"},
  })
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */

  const { criteria, field } = sort;
  const {
    typeAgency,
    agencyFrom,
    agencyTo,
    dateType,
    dateFrom,
    dateTo,
    type,
    gameId,
  } = filters;

  const dateFromFormat = dateFrom
    ?.toISOString()
    ?.split("T")[0]
    ?.split("-")
    ?.reverse()
    ?.join("-");
  const dateToFormat = dateTo
    ?.toISOString()
    ?.split("T")[0]
    ?.split("-")
    ?.reverse()
    ?.join("-");

  const url = `/delivery-service/prizes/payments/search-paid-prizes/unpaged?&orderCriteria=${criteria || "DESC"}&orderField=${field || "paymentDate"}`;

  const urlfilters = `${type ? `&gameType=${type}` : ""}${gameId ? `&gameId=${gameId}` : ""}${typeAgency ? `&agencyType=${typeAgency}` : ""}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ""}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ""}${dateType ? `&searchDateType=${dateType}` : ""}${dateFrom ? `&searchDateFrom=${dateFromFormat}` : ""}${dateTo ? `&searchDateTo=${dateToFormat}` : ""}`;

  const fetchUrl = url + urlfilters;

  try {
    const response = await apiClient.get(fetchUrl);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllPaymentsPrizes EP: ", error);
    throw error;
  }
};

const getPreprintedMatrizData = async (page, pageSize, sort, filters) => {
  /* const { agencyFrom, agencyTo, gameId, drawDate  } = filters;
  const date = new Date(drawDate).toISOString().split('T')[0].split('-').reverse().join('-');

  return fetch(`${getDeliveryServiceUrl()}/controlmatrix/preprinted?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${sort?.field || 'agencyNumber'}&orderCriteria=${sort?.criteria || 'DESC'}${date ? `&searchDate=${date}` : ''}${gameId ? `&gameId=${gameId}` : ''}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ''}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ''}`)
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */

  const { agencyFrom, agencyTo, gameId, drawDate } = filters;
  const date = new Date(drawDate)
    .toISOString()
    .split("T")[0]
    .split("-")
    .reverse()
    .join("-");

  let url = `/delivery-service/controlmatrix/preprinted?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${sort?.field || "agencyNumber"}&orderCriteria=${sort?.criteria || "DESC"}${date ? `&searchDate=${date}` : ""}${gameId ? `&gameId=${gameId}` : ""}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ""}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ""}`;

  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getPreprintedMatrizData EP: ", error);
    throw error;
  }
};

const getAllPreprintedMatrizData = async (sort, filters) => {
  /* const { agencyFrom, agencyTo, gameId, drawDate  } = filters;
  const date = new Date(drawDate).toISOString().split('T')[0].split('-').reverse().join('-');

  return fetch(`${getDeliveryServiceUrl()}/controlmatrix/preprinted/unpaged?&orderField=${sort?.field || 'agencyNumber'}&orderCriteria=${sort?.criteria || 'DESC'}${date ? `&searchDate=${date}` : ''}${gameId ? `&gameId=${gameId}` : ''}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ''}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ''}`)
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */
  const { agencyFrom, agencyTo, gameId, drawDate } = filters;
  const date = new Date(drawDate)
    .toISOString()
    .split("T")[0]
    .split("-")
    .reverse()
    .join("-");

  let url = `/delivery-service/controlmatrix/preprinted/unpaged?&orderField=${sort?.field || "agencyNumber"}&orderCriteria=${sort?.criteria || "DESC"}${date ? `&searchDate=${date}` : ""}${gameId ? `&gameId=${gameId}` : ""}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ""}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ""}`;

  try {
    const response = await apiClient.get(url);
    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllPreprintedMatrizData EP, ", error);
    throw error;
  }
};

const getInstantMatrizData = async (page, pageSize, sort, filters) => {
  /* const { agencyFrom, agencyTo, gameId, createDate, series } = filters;
  const date = new Date(createDate).toISOString().split('T')[0].split('-').reverse().join('-');
  const seriesString = series.reduce((acc, b) => acc += `&seriesName=${b}`, '');

  return fetch(`${getDeliveryServiceUrl()}/controlmatrix/instantaneous?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${sort?.field || 'agencyNumber'}&orderCriteria=${sort?.criteria || 'DESC'}${date ? `&searchDate=${date}` : ''}${gameId ? `&gameId=${gameId}` : ''}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ''}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ''}${seriesString}`)
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */
  const { agencyFrom, agencyTo, gameId, createDate, series } = filters;
  const date = new Date(createDate)
    .toISOString()
    .split("T")[0]
    .split("-")
    .reverse()
    .join("-");
  const seriesString = series.reduce(
    (acc, b) => (acc += `&seriesName=${b}`),
    "",
  );

  let url = `delivery-service/controlmatrix/instantaneous?pageNumber=${page || 1}&pageSize=${pageSize || 10}&orderField=${sort?.field || "agencyNumber"}&orderCriteria=${sort?.criteria || "DESC"}${date ? `&searchDate=${date}` : ""}${gameId ? `&gameId=${gameId}` : ""}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ""}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ""}${seriesString}`;

  try {
    const response = await apiClient.get(url);
    const data = response.data;

    return data;
  } catch (error) {
    console.error("Error at getInstantMatrizData EP: ", error);
    throw error;
  }
};

const getAllnstantMatrizData = async (sort, filters) => {
  /* const { agencyFrom, agencyTo, gameId, createDate, series } = filters;
  const date = new Date(createDate).toISOString().split('T')[0].split('-').reverse().join('-');
  const seriesString = series.reduce((acc, b) => acc += `&seriesName=${b}`, '');

  return fetch(`${getDeliveryServiceUrl()}/controlmatrix/instantaneous/unpaged?&orderField=${sort?.field || 'agencyNumber'}&orderCriteria=${sort?.criteria || 'DESC'}${date ? `&searchDate=${date}` : ''}${gameId ? `&gameId=${gameId}` : ''}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ''}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ''}${seriesString}`)
  .then(res => {
    if (res.status === 200) {
      return res.json();
    } else {
      throw { res, isServiceException: true }
    }
  })
  .catch(async (e) => {
    if (!e.isServiceException) {
      throw e
    } else {
      const res = await e.res.json();
      throw { ...res, isServiceException: true }
    }
  }) */
  const { agencyFrom, agencyTo, gameId, createDate, series } = filters;
  const date = new Date(createDate)
    .toISOString()
    .split("T")[0]
    .split("-")
    .reverse()
    .join("-");
  const seriesString = series.reduce(
    (acc, b) => (acc += `&seriesName=${b}`),
    "",
  );

  let url = `/delivery-service/controlmatrix/instantaneous/unpaged?&orderField=${sort?.field || "agencyNumber"}&orderCriteria=${sort?.criteria || "DESC"}${date ? `&searchDate=${date}` : ""}${gameId ? `&gameId=${gameId}` : ""}${agencyFrom ? `&agencyNumberFrom=${agencyFrom}` : ""}${agencyTo ? `&agencyNumberTo=${agencyTo}` : ""}${seriesString}`;
  try {
    const response = await apiClient.get(url);
    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error at getAllnstantMatrizData EP: ", error);
    throw error;
  }
};

const reportService = {
  getPaymentsPrizes,
  getAllPaymentsPrizes,
  getReceipts,
  getAllReceipts,
  getStock,
  getAllStock,
  getPreprintedMatrizData,
  getAllPreprintedMatrizData,
  getInstantMatrizData,
  getAllnstantMatrizData,
};

export default reportService;
